export { default } from "./SyndicateModal";
